(async function(){

	if (document.readyState !== "loading") {
		await onReady(); // Or setTimeout(onReady, 0); if you want it consistently async
	} else {
		document.addEventListener("DOMContentLoaded", onReady);
	}

	// mains

	async function onReady() {
		if( pageHasToc() ) {
			await setupToc();
		}
	}

	async function setupToc() {
		var toc_container = document.querySelector('.etna-block-toc'),
			toc_title = document.querySelector('.etna-block-toc__title'),
			toc_list = document.querySelector('.etna-block-toc__list'),
			post_headings = document.querySelector('.eii-content').querySelectorAll('h2'), //, h3, h4, h5, h6
			toc_links;

		if ( toc_container && toc_title && toc_list && post_headings ) {
			toc_links = toc_container.querySelectorAll('.etna-block-toc__list .etna-block-toc__link');

			// setup toc link clicks

			if (toc_links) {
				toc_links.forEach((link) => {

					link.addEventListener('click', event => {
						var targetHeadingHref = link.dataset.href.split('#')[1],
							targetHeadingText = link.textContent;

						if (targetHeadingHref) {
							post_headings.forEach(function(ele) {
								//if (ele.innerText.indexOf(targetHeadingText) > -1) {
								if (ele.id === targetHeadingHref) {
									if (typeof eiiScrollTo === 'function') {
										eiiScrollTo(ele, window.scrollY, 70);
									} else {
										ele.scrollIntoView({
											block: "start",
											inline: "nearest",
											behavior: "smooth"
										});
									}
								}
							});
						}
					});
				});
			}

			// 4080 - move above hero copy
			toc_container.parentNode.prepend(toc_container);

			// add open/close toggle
			toc_container.classList.add('closed');
			toc_title.addEventListener('click', newevent => {
				let winW = getWindowWidth(),
					bpW = breakpointWidth();

				if ( winW < bpW ) {
					if (toc_container.classList.contains('closed')) {
						toc_container.classList.add('opened');
						toc_container.classList.remove('closed');
					} else {
						toc_container.classList.add('closed');
						toc_container.classList.remove('opened');
					}
				}
			})
		}
	}

	// helpers

	function pageHasToc() {
		return ( document.querySelector('.etna-block-toc') ) ? true : false;
	}

	function eiiScrollTo(thisAnchor, fromHere, framesLeft) {
		var headerHeight = '150',
			frameDelay = 5,
			anchorTop = thisAnchor.getBoundingClientRect().top - headerHeight,
			bodyTop = document.body.getBoundingClientRect().top,
			anchorScrollPos = anchorTop - bodyTop,
			distanceLeft = anchorTop,
			scrollDistance = distanceLeft / framesLeft,
			scrollPos = fromHere + scrollDistance;

		if (framesLeft == 1) {

			window.scrollTo(0, anchorScrollPos);
			return;

		} else {

			window.scrollTo(0, scrollPos);

			framesLeft--;

			setTimeout(function(){
				eiiScrollTo(thisAnchor, scrollPos, framesLeft);
			}, frameDelay);

		}
	}

	function breakpointWidth() {
		// ios bug with 768 <=> 782
		var isSafari = false,
			breakpoint;

		isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
					navigator.userAgent &&
					navigator.userAgent.indexOf('CriOS') == -1 &&
					navigator.userAgent.indexOf('FxiOS') == -1;

		breakpoint = 768;

		if (isSafari) {
			breakpoint = 783;
		}

		return breakpoint;
	}

	function getWindowWidth() {
		return Math.max(
			document.documentElement.clientWidth,
			window.innerWidth || 0
		);
	}

})();
